<!-- Catalogo.svelte -->

<script>
	import Producto from './producto/Producto.svelte'
	import ProductoForm from './producto/ProductoForm.svelte'
	import Usuarios from './usuarios/Usuarios.svelte'
	import { usuario,filtro_cate, filtro_size, filtro_page , orden_dir, orden_por, view_type, filtro_buscar} from './store.js';
	import {execQuery} from './csql.js'


	export let producto = 0

	let ds = []
	let loading=false

	let contenedor

	let productos_ds = []

	let filtro_categoria = 'TODOS'
	let filtro_talle = ''
	let orden = false  // true:'ASC' | false:'DESC'

	let page = 0
	let rpp= 20
	let eof=false
	let update=false

	let where_clause = ''
	let order_clause = ' order by touched desc '

	let ver_formulario = false
	let ver_usuarios = false

	let activo=1

	$: {
		// console.log($filtro_size)
		page=0
		productos_ds=[]

		if(producto>0){
			where_clause = ` and id=${producto} `
		}else{
			where_clause = $filtro_cate==='TODOS' ? '' :` and categoria="${$filtro_cate}" `
			if($filtro_buscar){
				where_clause = where_clause + ` and ( (nombre like '%${$filtro_buscar}%') or (descrp like '%${$filtro_buscar}%') or (tag like '%${$filtro_buscar}%') )`
			}
			if($filtro_size !== "''"){
				where_clause = where_clause + ` and id in (select idproducto from stock where trim(substring_index(size,'(',1)) in (${$filtro_size}) and status=1 and (qtty-qttysold)>0) `
				//where_clause = where_clause + ` and id in (select idproducto from stock where size in (${$filtro_size}) and status=1) `
			}
		}
		order_clause = ` order by ${$orden_por} ${$orden_dir} , touched`
		// if($orden_por==='ultimos'){	order_clause = ` order by touched ${$orden_dir} `	}
		// if($orden_por==='precios') { order_clause = ` order by importe0 ${$orden_dir},touched ` }
		// if($orden_por==='categorias') { order_clause = ` order by categoria ${$orden_dir},touched ` }
		getData()
	}


	function refresh(){
		// console.log("refrescando")
		page=0
		productos_ds=[]
		getData()
	}

	const getData = async () => {

		loading = true
		let aux_where = ''
		if(activo===1){
			aux_where = 'activo=1 and stocku>0'
		}else{
			aux_where = 'activo>=0'
		}
		let query = `select * from vproductos1 where ${aux_where} ${where_clause} ${order_clause} limit ${page*rpp},${rpp}`
		// console.log(query)
		const data = await execQuery({query})
		loading= false
		let ds = data.data[0] || []
		eof = ds.length<rpp?true:false
		productos_ds = [...productos_ds,...ds]
		//return productos_ds
	}

	function next_page(){
		page++
		getData()
	}

	function reset_filtro_cate(){
		filtro_cate.set('TODOS')
	}

	function change_activo(){
		activo = activo===1?0:1
		refresh()
	}

	function scrollTop(){
		window.scrollTo(0, 0)
		contenedor.scrollTo(0, contenedor.scrollHeight)
	}

	let menu=1


	function alCatalogo(){
		const url = new URL(location);
		url.searchParams.delete('pid');
		history.replaceState(null, null, url)
		producto=0
	}


</script>





{#if !ver_usuarios}
		{#if $filtro_buscar !== '' && $filtro_cate !== 'TODOS'}
			<div class="p-2 border rounded-md bg-yellow-500 hover:bg-yellow-200 text-center mx-10" on:click={reset_filtro_cate}><i>Buscar en todas las categorias</i></div>
		{/if}

	{#if $view_type==='grid'}

		<!-- herramientas del administrador -->
		<div class="row" style="padding:4px;">
			{#if $usuario.tipo==='ADMIN'}
					<span style="padding:8px;" on:click={change_activo}>{activo===1?' Todos':' Activos'}</span>
					<span style="padding:8px;" on:click={()=>ver_usuarios=true}>Usuarios</span>
			{/if}

	  	  {#if $usuario.tipo!=='MAYO' }
			<div id=marq><span id=orig>Precio de lista hasta 3 cuotas sin interes, transferencia o efectivo 15% OFF! (compras minoristas). <span id=copia>Precio de lista hasta 3 cuotas sin interes, transferencia o efectivo 15% OFF! (compras minoristas). </span></span></div>
		  {/if}

		</div>

		{#if producto>0}
			<button on:click={alCatalogo}>Ir al Catalogo</button>
		{/if}

		<div class="container">

			<div class="row h-center">
				{#each productos_ds as item, index}
					<Producto {item} on:updated={refresh} />
				{/each}
			</div>

		</div>
			{#if !eof}
				<button class="w-full" style="font-size:1.3em;font-weight:bold;padding:20px 4px;" on:click={()=>next_page()}>Ver m&aacute;s Productos</button>
			{:else if !loading}
				<pre>No hay mas productos en esta categoria.</pre>
			{:else}
				<p>Loading...</p>
			{/if}

	{/if}

	{#if $view_type==='list'}


		<div class="container  mx-auto overflow-auto mb-20 mx-2" bind:this={contenedor}>



			<div class="md:flex flex-col justify-center"  >



				{#each productos_ds as item, index}
					<Producto {item} on:updated={refresh}/>
				{/each}

			</div>
			{#if !eof}
				<button class="w-full" style="font-size:1.3em;font-weight:bold;" on:click={()=>next_page()}>M&aacute;s Productos</button>
			{:else if !loading}
				<pre>No hay mas productos en esta categoria.</pre>
			{:else}
				<p>Loading...</p>
			{/if}

		</div>
	{/if}

	<span style="position:fixed;bottom:10px;right:10px;">

		<!-- <img src="images/up.png" alt="" class="h-12 rounded-xl"> -->
		<button style="background-color:black;color:white;border-radius:50%;padding:2px 12px;font-size:1.8em;margin:0px 1px;"
				 on:click={scrollTop}>&uarr;</button>
		{#if $usuario.tipo==='ADMIN'}
			<button style="background-color:red;color:white;border-radius:50%;padding:2px 12px;font-size:1.8em;margin:0px 1px;"
				on:click={()=>ver_formulario=true}>&plus;</button>
		{/if}
	</span>


	{#if ver_formulario}
		<ProductoForm bind:visible={ver_formulario}  on:updated={refresh}/>
	{/if}

{:else}
	<Usuarios on:close={()=>ver_usuarios=false}/>
{/if}

{#if $filtro_cate !== 'TODOS'}
	<pre><button class="secondary" on:click={()=>filtro_cate.set('TODOS')}>Todas las Categorias</button>{JSON.stringify($filtro_cate)}</pre>
{/if}
{#if $filtro_size !== "''"}
	<pre><button class="secondary" on:click={()=>filtro_size.set("''")}>Todos los talles</button>{JSON.stringify($filtro_size)}</pre>
{/if}
{#if $filtro_buscar.length>2}
	<pre><button class="secondary" on:click={()=>filtro_buscar.set('')}>Borrar busqueda</button>{JSON.stringify($filtro_buscar)}</pre>
{/if}
<!--
<pre><button class="secondary" on:click={()=>orden_dir.set(' desc ')}>&times;</button>{JSON.stringify($orden_dir)}</pre>
<pre><button class="secondary" on:click={()=>orden_por.set(' touched ')}>&times;</button>{JSON.stringify($orden_por)}</pre>
 -->
<style>
	.row>span{
		background-color:#666;
		color:white;
		margin-right: 3px;
		padding:0px 3px;
	}
	pre{
		padding-top: 4px;
		padding-bottom: 4px;
	}
	#marq {
	margin: 0.25em auto;
	width: 102em; height: 1.5em;
	/*border: inset; */
	overflow: hidden;
	white-space: nowrap;
	background-color: red;
	font: bold 150%/1.5 serif;
	color: white;
	font-size: 1.4em;
	}
	#orig {
	display: inline-block;
	transform: translatex(0);
	animation: marquesina 10s infinite normal linear 1s;
	}
	#copia{
	/*background-color: lime; */
	}
	@keyframes marquesina {
	  0% {transform: translatex(0); }
	  100% {transform: translatex(-50%); }
	}

</style>
